module.exports = __webpack_public_path__ + "files/b9ccf7867dff4a76b43890541215bebf.png";